// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --light-fg: #212121;
  --light-bg: #f2f2f4;
  --light-icon-hover: #b0b3b5;

  --dark-fg: #eee;
  --dark-bg: #222;
  --dark-icon-hover: #b0b3b5;

  --fg: var(--light-fg);
  --bg: var(--light-bg);
  --icon-hover: var(--light-icon-hover);

  --article-width: 60ch;

  --heading-font: "Atyp Display";
  --text-font: "Avenir";

  --text-size: 36px;
  --smaller-text-size: 20px;

  --z-ind-menu-underlay: 10;
  --z-ind-nav: 15;
  --z-ind-menu-invert-overlay: 20;
  --z-ind-menu-links: 25;
}

/* ===========================================================================
Reset
============================================================================ */

* {
  padding: 0;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-family: sans-serif; /* or your preferred typeface */
  line-height: 1.15; /* Adjust as needed */
  -webkit-text-size-adjust: 100%; /* Prevent adjustments in iOS */
}

input,
button,
textarea,
select {
  font: inherit; /* Ensure font consistency */
}

a {
  text-decoration: none; /* Or your preferred style */
  color: inherit; /* Optional: ensures links use the text color */
}

ul,
ol {
  list-style: none; /* If you prefer no default list markers */
}

table {
  border-collapse: collapse; /* Ensure borders are consistent */
}
th,
td {
  text-align: left; /* Adjust based on design */
  padding: 8px; /* Adjust as needed */
}

img {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
  max-width: 100%;
  height: auto;
}

/* ===========================================================================
General rules
============================================================================ */

body {
  font-family: var(--text-font);
  font-size: var(--text-size);
  color: var(--fg);
  background-color: var(--bg);
  overflow-x: hidden;
}

h1,
h2,
h3,
nav,
.hamburger-links {
  font-family: var(--heading-font);
  text-transform: uppercase;
  font-weight: bold;
}

h1 {
  font-size: 2em;
  font-variant: small-caps;
  font-weight: normal;
}

h2 {
  text-transform: lowercase;
  font-variant: small-caps;
  font-weight: normal;
  font-style: normal;
  font-size: 1.17em;
}

dt {
  font-weight: bold;
  text-transform: uppercase;
  font-family: var(--heading-font);
  margin-bottom: 0.5em;
}

dl,
dd {
  font-size: 1em;
  margin-bottom: 1em;
}

a {
  text-decoration: underline;
}

/* ===========================================================================
Custom styles
============================================================================ */

.loading-screen-white {
  background-color: var(--light-bg);
}

.loading-screen-black {
  background-color: var(--light-fg);
}

.background {
  background: center;
  background-image: var(--landing-background-image);
  /* background-image: var(--landing-background-image-set); */
  background-size: cover;
  background-repeat: no-repeat;
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: -1;
  width: 100%;
  height: 100%;
}

.dark-background {
  background-color: var(--dark-bg);
}

.landing-page {
  display: grid;
  justify-content: center;
  align-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-backdrop-filter: brightness(85%) blur(10px) invert(20%);
  backdrop-filter: brightness(85%) blur(10px) invert(20%);
  font-family: var(--heading-font);
  text-transform: uppercase;
}

#lower-left-title {
  bottom: 1em;
  left: 1em;
  position: absolute;
  font-size: 3em;
  color: var(--dark-fg);
}

.listen-album {
  text-decoration: none;
}

.album-cover {
  display: block;
  max-width: 25%;
  height: auto;
  align-self: center;
  justify-self: center;
  text-align: center;
}

.album-cover > a img {
  margin: 1em 0;
}

.enter-web {
  margin-top: 2rem;
  transition: color 0.2s;
}

.enter-web:hover {
  color: var(--icon-hover);
}

.social-icon {
  color: var(--icon-hover);
  transition: color 0.2s;
  margin: 10px;
  font-size: 30px;
}

.social-icon:hover {
  color: #2b2b2b;
}

.main-layout {
  display: grid;
  grid-template-rows: auto 1fr auto;
  min-height: 100dvh;
}

.main-layout-upper {
  display: grid;
  grid-template-rows: auto 1fr;
  min-height: 100dvh;
  justify-content: center;
  align-content: center;
  align-items: center;
  justify-items: center;
  z-index: 5;
}

.footer {
  background-color: var(--fg);
  color: var(--icon-hover);
  padding: 4em;
  text-align: center;
  font-size: 15px;
}

.footer a {
  text-decoration: none;
}

.copy {
  margin-top: 2em;
  line-height: 1.2;
}

.copy a {
  text-decoration: underline;
}

.whole-hamburger-menu {
  margin: 0;
  padding: 0;
}

.hamburger-menu-invert-overlay,
.hamburger-menu-underlay,
.hamburger-menu-links {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
}

.hamburger-menu-invert-overlay {
  background-color: transparent;
  -webkit-backdrop-filter: invert(1);
  backdrop-filter: invert(1);
  pointer-events: none;
  z-index: var(--z-ind-menu-invert-overlay);
}

.hamburger-menu-underlay {
  z-index: var(--z-ind-menu-underlay);
  background-color: #f2f2f4;
}

.hamburger-menu-links {
  z-index: var(--z-ind-menu-links);
  color: var(--bg);
  top: 3em;
  height: calc(100dvh - 3em);
}

.hamburger-links {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  height: 100%;
}

.hamburger-links li {
  list-style: none;
  padding: 0 0.5rem;
  margin: 0 0.5rem;
  font-size: 1.17em;
}

.hamburger-links li a {
  list-style: none;
  text-decoration: none;
  margin: 0;
  padding: 0;
}

.hamburger-links a:not(.active.title):hover,
.dropdown > span:hover {
  font-style: italic;
}

nav {
  z-index: 15;
}

.image-container {
  margin: auto;
  padding: 2em;
}

.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
}

.text {
  font-size: 24px;
  padding: 20px;
}

.image {
  width: 100%;
  max-width: 500px;
}

.iframe-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 2em;
  padding: 2em;
  width: 100vw;
}

.iframe-item {
  width: 100%;
  height: 100%;
  aspect-ratio: 16 / 9;
  border: none;
}

.video-release {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  padding-bottom: 2em;
}

.about-blaz {
  padding: 0 1em;
  margin: 1em 0;
  max-width: 60ch;
}

.about-blaz > p:not(:first-child) {
  padding-top: 1.5rem;
}

img.about-blaz-img {
  width: 100vw;
  height: 45dvh;
  object-fit: cover;
  object-position: 0 30%;
}

.contact {
  color: var(--fg);
  text-align: center;
}

img.contact-blaz-img {
  width: 100vw;
  height: 45dvh;
  object-position: 0 35%;
  object-fit: cover;
}

.top {
  --offset: 50px;

  position: sticky;
  bottom: 20px;
  margin-right: 10px;
  place-self: end;
  margin-top: calc(100vh + var(--offset));
  width: 45px;
  height: 45px;
  aspect-ratio: 1;
  background: var(--fg);
}

.top:before {
  content: "";
  position: absolute;
  inset: 30%;
  transform: translateY(20%) rotate(-45deg);
  border-top: 5px solid #fff;
  border-right: 5px solid #fff;
}

.discography-section-title {
  min-height: 100dvh;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.progress-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 10px;
  background: var(--fg);
  transform-origin: 0%;
  z-index: 2;
}

.review-progress-bar {
  height: 10px;
  background-color: var(--dark-icon-hover);
  transform-origin: 0%;
  z-index: 5;
}

.section-content h2 {
  font-size: 48px;
  text-align: center;
  margin-bottom: 1em;
}

.album-info {
  display: grid;
  padding: 2rem;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  align-items: center;
  justify-items: center;
  margin: 4em auto 0 auto;
  max-width: 90vw;
  letter-spacing: 0.5px;
}

.album-info-cover {
  max-width: 100%;
  height: auto;
}

.more-info {
  text-align: center;
  /* padding: 1em; */
}

.more-info > p {
  padding-top: 1em;
}

.more-info ul {
  padding-top: 1em;
}

.more-info li {
  display: inline-block;
  padding-right: 1em;
  color: var(--light-icon-hover);
  letter-spacing: 0;
}

.about-releases {
  margin-top: 1em;
  margin-bottom: 2em;
  background-color: var(--fg);
  color: var(--bg);
  width: 100vw;
  display: grid;
  align-items: center;
  justify-items: center;
  justify-content: center;
}

.about-releases-content {
  max-width: 60ch;
}

.reviews {
  margin-top: 2em;
  background-color: var(--fg);
  color: var(--bg);
  width: 100vw;
  display: grid;
  align-items: center;
  justify-items: center;
  justify-content: center;
}

.reviews > blockquote {
  grid-area: 1 / 1 / 2 / 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 60ch;
}

.reviews > blockquote > footer {
  padding-top: 1em;
  margin-left: auto;
  text-align: end;
}

.gallery {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 40px 20px 0 20px;
}

.additional-z {
  z-index: 17;
}

.gallery .box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.gallery .box .dream {
  display: flex;
  flex-direction: column;
  width: 32.5%;
}

.gallery .box .dream img {
  width: 100%;
  padding-bottom: 15px;
}

.prev-next {
  padding: 3em 1em;
}

@media screen and (max-width: 1380px) {
  .prev-next {
    padding: 2em 0 2em 0;
  }
}

@media screen and (max-width: 1230px) {
  body {
    font-size: calc(1.7dvw + 1.7dvh + 0.8dvmin);
  }

  .background {
    background-position: 75% center;
    background-size: 350% auto;
  }

  #lower-left-title {
    display: none;
  }

  .additional-z {
    z-index: auto;
  }
  /* FOR SMALLER SCREENS ABOUT BLAZ */
  .about-blaz,
  .contact {
    width: auto;
    padding: 0 0.25em;
  }

  img.about-blaz-img,
  img.contact-blaz-img {
    height: 40dvh;
  }

  .about-blaz > p:not(:first-child) {
    padding-top: 1rem;
  }

  .footer {
    font-size: 12px;
  }

  .album-info {
    display: grid;
    grid-template-columns: 1fr;
  }

  .iframe-grid {
    grid-template-columns: 1fr;
    grid-gap: 1em;
    padding: 1em;
  }
}

@media screen and (max-width: 1024px) {
  .album-cover {
    max-width: 35%;
  }

  .enter-web {
    font-size: 5vw;
  }
}

@media screen and (max-width: 930px) {
  .album-cover {
    font-size: 3vw;
  }
}

@media screen and (max-width: 812px) {
  .gallery .box {
    flex-direction: column;
  }

  .gallery .box .dream {
    width: 100%;
  }
}

@media only screen and (max-width: 769px) {
  .container .box {
    flex-direction: column;
  }

  .gallery .box .dream {
    width: 100%;
  }
}

@media screen and (max-width: 662px) {
  .album-cover {
    max-width: 70%;
    font-size: 6vw;
  }

  .enter-web {
    font-size: 8vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;;EAE3B,eAAe;EACf,eAAe;EACf,0BAA0B;;EAE1B,qBAAqB;EACrB,qBAAqB;EACrB,qCAAqC;;EAErC,qBAAqB;;EAErB,8BAA8B;EAC9B,qBAAqB;;EAErB,iBAAiB;EACjB,yBAAyB;;EAEzB,yBAAyB;EACzB,eAAe;EACf,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;;8EAE8E;;AAE9E;EACE,UAAU;AACZ;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB,EAAE,+BAA+B;EACxD,iBAAiB,EAAE,qBAAqB;EACxC,8BAA8B,EAAE,+BAA+B;AACjE;;AAEA;;;;EAIE,aAAa,EAAE,4BAA4B;AAC7C;;AAEA;EACE,qBAAqB,EAAE,4BAA4B;EACnD,cAAc,EAAE,+CAA+C;AACjE;;AAEA;;EAEE,gBAAgB,EAAE,0CAA0C;AAC9D;;AAEA;EACE,yBAAyB,EAAE,kCAAkC;AAC/D;AACA;;EAEE,gBAAgB,EAAE,2BAA2B;EAC7C,YAAY,EAAE,qBAAqB;AACrC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,eAAe;EACf,aAAa;EACb,wBAAwB;EACxB,eAAe;EACf,YAAY;AACd;;AAEA;;8EAE8E;;AAE9E;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;;;;EAKE,gCAAgC;EAChC,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;8EAE8E;;AAE9E;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;EACjD,2DAA2D;EAC3D,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,+DAA+D;EAC/D,uDAAuD;EACvD,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;;;EAGE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,0BAA0B;EAC1B,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,cAAc;;EAEd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uCAAuC;EACvC,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,yCAAyC;EACzC,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE,+BAA+B;IAC/B,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;EACA,mCAAmC;EACnC;;IAEE,WAAW;IACX,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,aAAa;IACb,YAAY;EACd;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[":root {\n  --light-fg: #212121;\n  --light-bg: #f2f2f4;\n  --light-icon-hover: #b0b3b5;\n\n  --dark-fg: #eee;\n  --dark-bg: #222;\n  --dark-icon-hover: #b0b3b5;\n\n  --fg: var(--light-fg);\n  --bg: var(--light-bg);\n  --icon-hover: var(--light-icon-hover);\n\n  --article-width: 60ch;\n\n  --heading-font: \"Atyp Display\";\n  --text-font: \"Avenir\";\n\n  --text-size: 36px;\n  --smaller-text-size: 20px;\n\n  --z-ind-menu-underlay: 10;\n  --z-ind-nav: 15;\n  --z-ind-menu-invert-overlay: 20;\n  --z-ind-menu-links: 25;\n}\n\n/* ===========================================================================\nReset\n============================================================================ */\n\n* {\n  padding: 0;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml {\n  font-family: sans-serif; /* or your preferred typeface */\n  line-height: 1.15; /* Adjust as needed */\n  -webkit-text-size-adjust: 100%; /* Prevent adjustments in iOS */\n}\n\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit; /* Ensure font consistency */\n}\n\na {\n  text-decoration: none; /* Or your preferred style */\n  color: inherit; /* Optional: ensures links use the text color */\n}\n\nul,\nol {\n  list-style: none; /* If you prefer no default list markers */\n}\n\ntable {\n  border-collapse: collapse; /* Ensure borders are consistent */\n}\nth,\ntd {\n  text-align: left; /* Adjust based on design */\n  padding: 8px; /* Adjust as needed */\n}\n\nimg {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n  max-width: 100%;\n  height: auto;\n}\n\n/* ===========================================================================\nGeneral rules\n============================================================================ */\n\nbody {\n  font-family: var(--text-font);\n  font-size: var(--text-size);\n  color: var(--fg);\n  background-color: var(--bg);\n  overflow-x: hidden;\n}\n\nh1,\nh2,\nh3,\nnav,\n.hamburger-links {\n  font-family: var(--heading-font);\n  text-transform: uppercase;\n  font-weight: bold;\n}\n\nh1 {\n  font-size: 2em;\n  font-variant: small-caps;\n  font-weight: normal;\n}\n\nh2 {\n  text-transform: lowercase;\n  font-variant: small-caps;\n  font-weight: normal;\n  font-style: normal;\n  font-size: 1.17em;\n}\n\ndt {\n  font-weight: bold;\n  text-transform: uppercase;\n  font-family: var(--heading-font);\n  margin-bottom: 0.5em;\n}\n\ndl,\ndd {\n  font-size: 1em;\n  margin-bottom: 1em;\n}\n\na {\n  text-decoration: underline;\n}\n\n/* ===========================================================================\nCustom styles\n============================================================================ */\n\n.loading-screen-white {\n  background-color: var(--light-bg);\n}\n\n.loading-screen-black {\n  background-color: var(--light-fg);\n}\n\n.background {\n  background: center;\n  background-image: var(--landing-background-image);\n  /* background-image: var(--landing-background-image-set); */\n  background-size: cover;\n  background-repeat: no-repeat;\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  z-index: -1;\n  width: 100%;\n  height: 100%;\n}\n\n.dark-background {\n  background-color: var(--dark-bg);\n}\n\n.landing-page {\n  display: grid;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  -webkit-backdrop-filter: brightness(85%) blur(10px) invert(20%);\n  backdrop-filter: brightness(85%) blur(10px) invert(20%);\n  font-family: var(--heading-font);\n  text-transform: uppercase;\n}\n\n#lower-left-title {\n  bottom: 1em;\n  left: 1em;\n  position: absolute;\n  font-size: 3em;\n  color: var(--dark-fg);\n}\n\n.listen-album {\n  text-decoration: none;\n}\n\n.album-cover {\n  display: block;\n  max-width: 25%;\n  height: auto;\n  align-self: center;\n  justify-self: center;\n  text-align: center;\n}\n\n.album-cover > a img {\n  margin: 1em 0;\n}\n\n.enter-web {\n  margin-top: 2rem;\n  transition: color 0.2s;\n}\n\n.enter-web:hover {\n  color: var(--icon-hover);\n}\n\n.social-icon {\n  color: var(--icon-hover);\n  transition: color 0.2s;\n  margin: 10px;\n  font-size: 30px;\n}\n\n.social-icon:hover {\n  color: #2b2b2b;\n}\n\n.main-layout {\n  display: grid;\n  grid-template-rows: auto 1fr auto;\n  min-height: 100dvh;\n}\n\n.main-layout-upper {\n  display: grid;\n  grid-template-rows: auto 1fr;\n  min-height: 100dvh;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  justify-items: center;\n  z-index: 5;\n}\n\n.footer {\n  background-color: var(--fg);\n  color: var(--icon-hover);\n  padding: 4em;\n  text-align: center;\n  font-size: 15px;\n}\n\n.footer a {\n  text-decoration: none;\n}\n\n.copy {\n  margin-top: 2em;\n  line-height: 1.2;\n}\n\n.copy a {\n  text-decoration: underline;\n}\n\n.whole-hamburger-menu {\n  margin: 0;\n  padding: 0;\n}\n\n.hamburger-menu-invert-overlay,\n.hamburger-menu-underlay,\n.hamburger-menu-links {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n}\n\n.hamburger-menu-invert-overlay {\n  background-color: transparent;\n  -webkit-backdrop-filter: invert(1);\n  backdrop-filter: invert(1);\n  pointer-events: none;\n  z-index: var(--z-ind-menu-invert-overlay);\n}\n\n.hamburger-menu-underlay {\n  z-index: var(--z-ind-menu-underlay);\n  background-color: #f2f2f4;\n}\n\n.hamburger-menu-links {\n  z-index: var(--z-ind-menu-links);\n  color: var(--bg);\n  top: 3em;\n  height: calc(100dvh - 3em);\n}\n\n.hamburger-links {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center;\n  height: 100%;\n}\n\n.hamburger-links li {\n  list-style: none;\n  padding: 0 0.5rem;\n  margin: 0 0.5rem;\n  font-size: 1.17em;\n}\n\n.hamburger-links li a {\n  list-style: none;\n  text-decoration: none;\n  margin: 0;\n  padding: 0;\n}\n\n.hamburger-links a:not(.active.title):hover,\n.dropdown > span:hover {\n  font-style: italic;\n}\n\nnav {\n  z-index: 15;\n}\n\n.image-container {\n  margin: auto;\n  padding: 2em;\n}\n\n.grid-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  align-items: center;\n}\n\n.text {\n  font-size: 24px;\n  padding: 20px;\n}\n\n.image {\n  width: 100%;\n  max-width: 500px;\n}\n\n.iframe-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 2em;\n  padding: 2em;\n  width: 100vw;\n}\n\n.iframe-item {\n  width: 100%;\n  height: 100%;\n  aspect-ratio: 16 / 9;\n  border: none;\n}\n\n.video-release {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  padding-bottom: 2em;\n}\n\n.about-blaz {\n  padding: 0 1em;\n  margin: 1em 0;\n  max-width: 60ch;\n}\n\n.about-blaz > p:not(:first-child) {\n  padding-top: 1.5rem;\n}\n\nimg.about-blaz-img {\n  width: 100vw;\n  height: 45dvh;\n  object-fit: cover;\n  object-position: 0 30%;\n}\n\n.contact {\n  color: var(--fg);\n  text-align: center;\n}\n\nimg.contact-blaz-img {\n  width: 100vw;\n  height: 45dvh;\n  object-position: 0 35%;\n  object-fit: cover;\n}\n\n.top {\n  --offset: 50px;\n\n  position: sticky;\n  bottom: 20px;\n  margin-right: 10px;\n  place-self: end;\n  margin-top: calc(100vh + var(--offset));\n  width: 45px;\n  height: 45px;\n  aspect-ratio: 1;\n  background: var(--fg);\n}\n\n.top:before {\n  content: \"\";\n  position: absolute;\n  inset: 30%;\n  transform: translateY(20%) rotate(-45deg);\n  border-top: 5px solid #fff;\n  border-right: 5px solid #fff;\n}\n\n.discography-section-title {\n  min-height: 100dvh;\n  display: flex;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n}\n\n.progress-bar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 10px;\n  background: var(--fg);\n  transform-origin: 0%;\n  z-index: 2;\n}\n\n.review-progress-bar {\n  height: 10px;\n  background-color: var(--dark-icon-hover);\n  transform-origin: 0%;\n  z-index: 5;\n}\n\n.section-content h2 {\n  font-size: 48px;\n  text-align: center;\n  margin-bottom: 1em;\n}\n\n.album-info {\n  display: grid;\n  padding: 2rem;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n  align-items: center;\n  justify-items: center;\n  margin: 4em auto 0 auto;\n  max-width: 90vw;\n  letter-spacing: 0.5px;\n}\n\n.album-info-cover {\n  max-width: 100%;\n  height: auto;\n}\n\n.more-info {\n  text-align: center;\n  /* padding: 1em; */\n}\n\n.more-info > p {\n  padding-top: 1em;\n}\n\n.more-info ul {\n  padding-top: 1em;\n}\n\n.more-info li {\n  display: inline-block;\n  padding-right: 1em;\n  color: var(--light-icon-hover);\n  letter-spacing: 0;\n}\n\n.about-releases {\n  margin-top: 1em;\n  margin-bottom: 2em;\n  background-color: var(--fg);\n  color: var(--bg);\n  width: 100vw;\n  display: grid;\n  align-items: center;\n  justify-items: center;\n  justify-content: center;\n}\n\n.about-releases-content {\n  max-width: 60ch;\n}\n\n.reviews {\n  margin-top: 2em;\n  background-color: var(--fg);\n  color: var(--bg);\n  width: 100vw;\n  display: grid;\n  align-items: center;\n  justify-items: center;\n  justify-content: center;\n}\n\n.reviews > blockquote {\n  grid-area: 1 / 1 / 2 / 2;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  max-width: 60ch;\n}\n\n.reviews > blockquote > footer {\n  padding-top: 1em;\n  margin-left: auto;\n  text-align: end;\n}\n\n.gallery {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  margin: 40px 20px 0 20px;\n}\n\n.additional-z {\n  z-index: 17;\n}\n\n.gallery .box {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.gallery .box .dream {\n  display: flex;\n  flex-direction: column;\n  width: 32.5%;\n}\n\n.gallery .box .dream img {\n  width: 100%;\n  padding-bottom: 15px;\n}\n\n.prev-next {\n  padding: 3em 1em;\n}\n\n@media screen and (max-width: 1380px) {\n  .prev-next {\n    padding: 2em 0 2em 0;\n  }\n}\n\n@media screen and (max-width: 1230px) {\n  body {\n    font-size: calc(1.7dvw + 1.7dvh + 0.8dvmin);\n  }\n\n  .background {\n    background-position: 75% center;\n    background-size: 350% auto;\n  }\n\n  #lower-left-title {\n    display: none;\n  }\n\n  .additional-z {\n    z-index: auto;\n  }\n  /* FOR SMALLER SCREENS ABOUT BLAZ */\n  .about-blaz,\n  .contact {\n    width: auto;\n    padding: 0 0.25em;\n  }\n\n  img.about-blaz-img,\n  img.contact-blaz-img {\n    height: 40dvh;\n  }\n\n  .about-blaz > p:not(:first-child) {\n    padding-top: 1rem;\n  }\n\n  .footer {\n    font-size: 12px;\n  }\n\n  .album-info {\n    display: grid;\n    grid-template-columns: 1fr;\n  }\n\n  .iframe-grid {\n    grid-template-columns: 1fr;\n    grid-gap: 1em;\n    padding: 1em;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .album-cover {\n    max-width: 35%;\n  }\n\n  .enter-web {\n    font-size: 5vw;\n  }\n}\n\n@media screen and (max-width: 930px) {\n  .album-cover {\n    font-size: 3vw;\n  }\n}\n\n@media screen and (max-width: 812px) {\n  .gallery .box {\n    flex-direction: column;\n  }\n\n  .gallery .box .dream {\n    width: 100%;\n  }\n}\n\n@media only screen and (max-width: 769px) {\n  .container .box {\n    flex-direction: column;\n  }\n\n  .gallery .box .dream {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 662px) {\n  .album-cover {\n    max-width: 70%;\n    font-size: 6vw;\n  }\n\n  .enter-web {\n    font-size: 8vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
